import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import itIT from "antd/locale/it_IT";
import { ConfigProvider } from "antd";
import { AuthProvider } from "./contexts/authContext";
import { LoaderProvider } from "./contexts/LoaderContext";
import it from "antd/es/date-picker/locale/it_IT";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const italiano: typeof itIT = {
  ...itIT,
  DatePicker: {
    ...itIT.DatePicker!,
    lang: it.lang,
  },
};

root.render(
  // <React.StrictMode>
  <ConfigProvider locale={italiano}>
    <BrowserRouter>
      <AuthProvider>
        <LoaderProvider>
          <App />
        </LoaderProvider>
      </AuthProvider>
    </BrowserRouter>
  </ConfigProvider>
  // </React.StrictMode>
);
